<template>
  <div class="" style="position:fixed">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-container fluid style="padding-top: 100px;text-align:left">
          <b-row>
            <b-col cols="12 headerF"><HeaderConsumer/></b-col>
            <b-col cols="12 headerM"><HeaderConsumerMobile/></b-col>
          </b-row>

  <br>
  <form id="form-add-contact">
        <b-row style="width:100vw">
                <b-col col cols="12" sm="3" md="3" lg="3" class="sideNav">
                    <AdminSideNav />
                </b-col>
                <b-col col cols="12" sm="12" md="9" lg="9" style="height:78vh; overflow-y:scroll " class="shadow">
                  <b-row>
                    <b-col col cols="12" sm="12" md="12" lg="12">
                     <h1 class="heading">Contact Details Update</h1>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col col cols="12" sm="12" md="3" lg="3" class="text-left">
                      <h6>Office Type: </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="3" lg="3" >

                      <select id="officeType" class="browser-default" name="officeType" style="background-color: #fafafa;" @change="selectOfficeShow()">
                        <option value="" disabled selected>Choose your option</option>
                        <!-- <option value="hq">Headquarter</option> -->
                        <option value="z">Zone</option>
                        <option value="c">Circle</option>
                        <option value="d">Division</option>
                        <option value="sd">Sub-Division</option>
                      </select>
                    </b-col>
                    <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                      <h6>Office Name: </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="3" lg="3">
                      <select id="officeName" class="browser-default" name="officeName"  @change="getSavedContact()" style="background-color: #fafafa;">
                        <option value="" disabled selected>Choose your option</option>
                      </select>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                      <h6>Contact Person: </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="3" lg="3">
                        <input id="contactPerson" type="text" class="validate" name="contactPerson" placeholder="Enter contact person">
                      </b-col>

                    <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                      <h6>Designation: </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="3" lg="3">
                      <input id="designation" type="text" class="validate" name="designation" placeholder="Enter designation">
                      </b-col>
                  </b-row><br>
                  <b-row>
                    <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                      <h6>Email:  </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="3" lg="3">
                      <input id="email" type="text" class="validate" name="email" placeholder="Enter email-id">
                      </b-col>

                    <b-col col cols="12" sm="12" md="3" lg="3" class="text-left">
                      <h6>Mobile Number: </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="3" lg="3" >
                      <input id="mobile" type="text" class="validate" name="mobileNo" placeholder="Enter mobile number">
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="6" sm="6" md="2" lg="2" offset-md="4" offset-lg="4" class="text-center">
                      <b-button variant="info" @click="addContact($event)">UPDATE</b-button>
                    </b-col>
                    <b-col col cols="6" sm="6" md="2" lg="2" class="text-center">
                      <b-button variant="outline-danger">CANCEL</b-button>
                    </b-col>
                  </b-row>

            </b-col>
      </b-row>
    </form>
      </b-container>
      <br><br>
</b-overlay>


      <b-modal   no-close-on-esc  no-close-on-backdrop   hide-header id="successModal" centered  scrollable title="Complaint Update" hide-footer>
        <br><br><svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
          <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
          <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
        </svg>
        <p class="success">Contact Successfully Updated !<br><br>
        <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage();" >OK</b-button>
        </p>
      </b-modal>
      <b-modal  no-close-on-esc  no-close-on-backdrop   hide-header id="failureModal" centered  scrollable title="Complaint Update" hide-footer>
      <br><br>  <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
          <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
        </svg>
        <p class="error">Contact Update Failed ! <br><br>
          <b-button class="btn btn-outline" variant="danger" id="" @click="reloadPage();" >OK</b-button>
           </p>
      </b-modal>
  </div>
</template>

<script>
import AdminSideNav from '@/components/AdminSideNav.vue'
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex';

//var urlCommon = "https://portald.apdcl.org/website";
var urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
var selectedId = null;
export default {
  name: 'Admin',
  components: {
    'AdminSideNav' : AdminSideNav,
    'HeaderConsumer' : HeaderConsumer,
    'HeaderConsumerMobile' : HeaderConsumerMobile

  },
  data() {
      return {
        value: '',
        show: false,
      }
    },
    computed:
    {
      ...mapGetters([
        'getZoneData',
        'getKeyOfficial',
        'getCircleContact',
        'getDivisionContact',
        'getSubDivContact',
        'getIRCAContact',
        'getTCContact'
      ])

    },

  methods:
  {
    ...mapActions([
      'retrieveContactInfo'
    ]),
    selectOfficeShow(){

       var  val = document.getElementById("officeType").value;
       document.querySelectorAll('#officeName option').forEach(option => option.remove());

       axios.get(urlCommon + "/api/admin/officeList?officeType=" + val).then(function(response) {
         var x = document.getElementById("officeName");

         var option = document.createElement("option");
         option.text = "Choose your option";
         option.value = "";
         x.options.add(option);

         response.data.forEach(element => {
           var option = document.createElement("option");
           option.text = element;
           option.value = element;
           x.options.add(option);
         })

       })

    },
    getSavedContact(){

      // TODO: add validataion and return method
      var officeType = document.getElementById("officeType").value
      var officeName = document.getElementById("officeName").value

      axios.get(urlCommon + "/api/admin/showcontact?officeType=" + officeType + "&officeName=" + officeName).then(function(response) {

          var desig
          if(officeType== "z") { desig = "GM" }
          else  if(officeType== "c") { desig = "CEO" }
          else  if(officeType== "d") { desig = "AGM" }
          else  if(officeType== "sd") { desig = "SDE" }

          document.getElementById("contactPerson").value = response.data.contact_person;
          document.getElementById("designation").value = desig;
          document.getElementById("email").value =  response.data.email;
          document.getElementById("mobile").value =  response.data.mobile;
          selectedId =  response.data.id;
        })
    },
    addContact(event){
      event.stopPropagation()
      event.preventDefault()

      // TODO: add validataion and return method

      var dataToSend = {
        "id":selectedId,
        "officeType": document.getElementById("officeType").value,
        "officeName":document.getElementById("officeName").value,
        "contactPerson":document.getElementById("contactPerson").value,
        "designation":document.getElementById("designation").value,
        "email":document.getElementById("email").value,
        "mobileNo":document.getElementById("mobile").value,
      }

      console.log(dataToSend)
      // TODO: add loader
      var parent = this;
      parent.show=true;
      axios.post( urlCommon + "/api/admin/updatecontact", dataToSend).then(function(response) {
        console.log(response)
        parent.show=false;
        if (response.data == "success") {
          document.getElementById("form-add-contact").reset()
          parent.$bvModal.show('successModal');
        } else {
          document.getElementById("form-add-contact").reset()
          parent.$bvModal.show('profilefailureModal');
        }
      })


    },

    reloadPage()
    {
      window.location.reload();
    }
  },
  mounted()
  {
//  var userId = localStorage.getItem("userId");
//  var userName = localStorage.getItem("userName");
    var roles = localStorage.getItem("roleSet");
    if(roles==null)
      {
        this.$router.push({ path: '/' })
        return;
      }
    var i =0;
    var res= roles.split(",");
    for(i=0;i<res.length;i++)
     {
       if(res[i]!="ROLE_ADMIN")
       {
         document.getElementById(res[i]).style.display="block";
       }
     }
     document.getElementById("consName").innerHTML = userName ;
  }
}


</script>

<style scoped="true">

.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
  color: #0097a7 ;
}

li{
  padding:0;
}

body{
    overflow-y:hidden;
  }
.shadow{}
  .headerF{
  display: block;
}
.headerM{
  display: none;
}
.sideNav{
  height:75vh;
  overflow-y:auto;
}
.dropdownmenu{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }
  @media (max-width: 576px) {
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }


.path {
      stroke-dasharray: 1000;
      stroke-dashoffset: 0;
    }
    .path.circle {
      -webkit-animation: dash 0.9s ease-in-out;
      animation: dash 0.9s ease-in-out;
    }
    .path.line {
      stroke-dashoffset: 1000;
      -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
      animation: dash 0.9s 0.35s ease-in-out forwards;
    }
    .path.check {
      stroke-dashoffset: -100;
      -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
      animation: dash-check 0.9s 0.35s ease-in-out forwards;
    }

    p {
      text-align: center;
      margin: 20px 0 60px;
      font-size: 1.25em;
    }
    p.success {
      color: #73AF55;
    }
    p.error {
      color: #D06079;
    }
    @-webkit-keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @-webkit-keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }
    @keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }
</style>
